import { Card, CardContent, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const NavBar = () => {
  return (
    <Card style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
      <CardContent style={{ textAlign: 'center' }}>
        <Typography variant="h6" style={{ fontFamily: 'Lato, sans-serif' }}>
          <Link component={RouterLink} to="/" style={linkStyle}>
            Home
          </Link> |
          <Link component={RouterLink} to="/students" style={linkStyle}>
            Students
          </Link> |
          <Link component={RouterLink} to="/visualizations" style={linkStyle}>
            Visualizations
          </Link>|
          <Link component={RouterLink} to="/llm-coding" style={linkStyle}>
            LLM Coding
          </Link>
        </Typography>
      </CardContent>
    </Card>
  );
};

const linkStyle = {
  margin: '0 10px',
  textDecoration: 'none',
  color: '#1e0d36', // You can choose a color that matches your theme
  '&:hover': {
    textDecoration: 'underline',
    color: '#1565c0'
  }
};

export default NavBar;
